export const PaymentInputTypeList = ["CARD","SHABA"] as const;